<script>
export default {
  name: "loginHeader"
};
</script>

<template>
  <header>
    <div class="image-container">
      <img alt="Vue logo" src="../assets/ontest.svg">
    </div>
  </header>
</template>

<style scoped lang="scss">
header{
  height: 25%;
  display: flex;
}

.image-container{
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  width:100%;
}

img{
  max-width:100%;
  max-height:100%;
  object-fit: contain;
  padding: 10px;
}
</style>
